import { Grid, styled } from '@mui/material';

const PREFIX = 'FirmSettings';

export const classes = {
  firmLogoContainer: `${PREFIX}-firmLogoContainer`,
  helperText: `${PREFIX}-helperText`,
  textField: `${PREFIX}-textField`,
  checkBoxContainer: `${PREFIX}-checkBoxContainer`,
  checkBoxLabel: `${PREFIX}-checkBoxLabel`,
};

export const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.firmLogoContainer}`]: {
    marginTop: '-2rem',
  },

  [`& .${classes.helperText}`]: {},

  [`& .${classes.textField}`]: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: theme.palette.primary[700],
      fontSize: '1rem',
    },
  },

  [`& .${classes.checkBoxContainer}`]: {
    display: 'block',
  },

  [`& .${classes.checkBoxLabel}`]: {
    display: 'initial',
  },
}));